module.exports = __webpack_public_path__ + "static/img/browsers-v1.tid2.7390ba1.png";